import React, { useState } from 'react';
import { Button, Collapse, Divider } from 'antd';
import { EmptyState } from './EmptyState';
import SVG from 'react-inlinesvg';

import {
  PlusOutlined,
  PlusCircleOutlined,
  PlayCircleOutlined,
  FileAddOutlined,
} from '@ant-design/icons';

const { Panel } = Collapse;

const PageEmptyState = ({
  onPageAdd,
  onTutorialPageAdd,
}) => {

  const [videoFrame, setVideoFrame] = useState(false);

  return (
    <EmptyState
      title='No landing page yet'
      subtitle="Pages and variants you create will appear here."
      graphics={<SVG src={require('assets/media/page/page-empty.svg')} />}
      btnLabel="Create new page"
      btnIcon={<PlusOutlined />}
      btnCallback={onPageAdd}
    >
      <div>
        <Button type="dashed" icon={<PlusCircleOutlined />}
          onClick={onTutorialPageAdd}
          className="mx-2"
        >
          Tutorial page
        </Button>
        <Button type="dashed" icon={<PlayCircleOutlined />}
          onClick={() => this.setVideoFrame(true)}
          className="mx-2"
        >
          { videoFrame ? 'Playing how-to' : 'How-to video' }
        </Button>
      </div>
    </EmptyState>
  );

};

export { PageEmptyState };

//
// <h5 className="text-secondary mt-5 mb-3">FAQs</h5>
// <Collapse accordion className="text-left">
//   <Panel header="What are landing pages?" key="definition">
//     <p>
//       Landing pages are web-pages that people “land” on when they click a link
//       - typically from another website, or from within an email or an advertisement.
//     </p>
//     <p>
//       They’re the first surface of contact of your online traffic,
//       and your best opportunity to make a great first-impression.
//       Because of this, landing pages play a crucial role in your online sales.
//       Landing pages help generate leads and in turn, drives revenue.
//     </p>
//   </Panel>
//   <Panel header="How are landing pages different from websites?" key="landing-vs-website">
//     <p>
//       Landing pages focus on a narrow stream of traffic -
//       say from an ad campaign, with the sole intention of
//       converting these visitors to leads.
//       Compared to websites with broader audience
//       and wider objectives, landing pages must contain
//       targeted messaging that compels people to act - say
//       start a product trial or submit a form.
//     </p>
//     <p>
//       Differences aside, many people use the terms "landing pages"
//       and "websites" interchangeably when they talk about
//       single page websites.
//       Whether you should keep them separate or combined
//       depends on your marketing strategy and
//       what's right for your business.
//     </p>
//   </Panel>
//   <Panel header="What are page variants?" key="design-principles">
//     <p>
//       Variants allow you to manage your landing pages to have
//       multiple copies, so you can run AB tests.
//     </p>
//     <p>
//       AB testing is a powerful experimentation technique where
//       two or more variants of a page are shown to visitors at
//       random, and statistical analysis is used to determine which
//       variation gets better results.
//     </p>
//   </Panel>
//   <Panel header="How many pages and variants do I need?" key="3">
//     <p>
//       You would typically need one landing page per campaign.
//       Each page will have its own unique URL that you would set
//       as the target of the campaign.
//     </p>
//     <p>
//       A landing page on the other hand can have
//       as many variants as you wish,
//       depending on how many different messaging and layouts you
//       want to experiment with for that particular campaign.
//     </p>
//   </Panel>
// </Collapse>



// WEBPACK FOOTER //
// ./scripts/presentation/PageEmptyState.jsx